import { render, staticRenderFns } from "./PeralteeClaimDetail.vue?vue&type=template&id=bb7586a8&scoped=true&"
import script from "./PeralteeClaimDetail.vue?vue&type=script&lang=ts&"
export * from "./PeralteeClaimDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PeralteeClaimDetail.vue?vue&type=style&index=0&id=bb7586a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7586a8",
  null
  
)

export default component.exports